module.exports = __webpack_public_path__ + "img/MyGymChecker-Logo-JPEG-BlackBlue-transparent.4bfb65ae.jpg";